import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";
import DatePicker from "~/common/components/DatePicker";

import "~/assets/sass/pages/shareholder/edit.scss";
import { PlusIcon } from "~/assets/svg/MathIcon";
import PageHeader from "~/common/components/PageHeader";
import DetailInfo from "./DetailInfo";
import { UPLOAD_TYPE } from "~/common/constants/upload";
import SingleImageUploader from "~/common/components/ImageUploader/SingleImageUploader";
import useAlert from "~/common/hooks/useAlert";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import useRequest from "~/common/hooks/useRequest";
import SignatureUploadModal from "~/pages/mypage/admin/SignaturePage/SignatureUploadModal";
import {useNavigate} from "react-router";

const Edit = ({ shareholderDetail, menu, type, onCancel }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const langStatus = i18next.language;
	const { idx, title, regDate, ShareholderMember } = shareholderDetail;

	const [companyInfo, setCompanyInfo] = useState({});
	const [signImg, setSignImg] = useState(""); // 서명이미지
	const [showAlert, Alert] = useAlert();
	const [showCancelAlert, CancelAlert] = useAlert();

	const companyInfoApi = useRequest("get", `company/info`);
	const shareholderEditMutation = useRequest("post", "shareholder/edit");
	const shareholderAddMutation = useRequest("post", "shareholder/add");

	const onSubmit = (data) => {
		if(!signImg) {
			showAlert();
			return;
		}
		if(idx) {
			// 수정
			const paramData = {
				idx: idx,
				title: data.title,
				sign: signImg ?? "",
				regDate: data.regDate,
				shareholderMember: data.shareholderMember
			}
			shareholderEditMutation.asyncCall(paramData).then(() => {
				navigate("/shareholder/list");
			});
		} else {
			// 신규
			const paramData = {
				title: data.title,
				sign: signImg ?? "",
				regDate: data.regDate,
				shareholderMember: data.shareholderMember
			}
			shareholderAddMutation.asyncCall(paramData).then(() => {
				navigate("/shareholder/list");
			});
		}

	};

	const handleGetCompnayInfo = async () => {
		await companyInfoApi
			.asyncCall()
			.then(async (res) => {
				setCompanyInfo(res.data);
				setSignImg(res.data.signature.img)
			})
			.catch((e) => {
				console.log(e);
			});
	}

	const shareholderForm = useForm({
		defaultValues: { idx, title, regDate, shareholderMember: ShareholderMember },
	});



	const headerButtons = [
		<button
			type="button"
			className="btn__solid"
			color="gray"
			onClick={() => {
				showCancelAlert().then(() => onCancel());
			}}
		>
			{t("button.cancel")}
		</button>,
		<button
			type="button"
			className="btn__solid"
			color="primary"
			onClick={shareholderForm.handleSubmit((data) => onSubmit(data))}
		>
			{t("button.save")}
		</button>,
	];
	const [signRegisterModal, setSignRegisterModal] = useState(false);


	useEffect(() => {
		handleGetCompnayInfo();
	}, []);


	return (
		<>
			<PageHeader buttonList={headerButtons} menu={menu} type={type} />
			<div className="c__card shareholder-edit-card">
				<h3 className="section-title">
					{t("Shareholder.ShareholderDetail.Edit.DetailInfo.thead.info")}
				</h3>
				<section className="shareholder-card-info">
					<div className="form-label">{t("VcInfo.VcDetail.basic.basic-info-title")}</div>
					<Form useForm={shareholderForm}>
						<Input
							label={t("Community.board-table.title")}
							name="title"
							required={null}
							validation={{
								maxLength: {
									value: 100,
									message: t(
										"Shareholder.ShareholderDetail.Edit.Index.validationMsg"
									),
								},
							}}
						/>
						<DatePicker
							label={t("Shareholder.ShareholderDetail.Edit.Index.issueDate")}
							name="regDate"
							datePickerName="date-picker"
							required={null}
						/>
					</Form>
				</section>
				<section className="shareholder-form-table">
					<DetailInfo useForm={shareholderForm} />
				</section>
				<section className="shareholder-footer">
					<div className="info-area">
						<h2 className="company-name">{companyInfo?.company?.name}</h2>
						<p className="company-address">
							{companyInfo?.company?.address} {companyInfo?.company?.addressDetail}
						</p>
					</div>
					{
						signImg ?
							<section className="private-setting">
								<div className="signature-wrap">
									<div className="signature-part">
										<span className="label">signature</span>
										<div className="img-wrap">
											<SingleImageUploader
												uploaderConstant={UPLOAD_TYPE.USER_SIGN}
												width={236}
												height={122}
												img={signImg}
												setImg={setSignImg}
												name={"signImg"}
											/>
										</div>
									</div>
								</div>
							</section> :
							<section className="private-setting">
								<div className="signature-wrap">
									<div className="signature-part">
										<span className="label">signature</span>
										<button
											className={"register-signature-button"}
											onClick={() => setSignRegisterModal(true)}>
											<PlusIcon />
											법인인감등록하기
										</button>
									</div>
								</div>
							</section>
					}
				</section>
			</div>
			<ModalTemplate
				title={t("MyPage.admin.Signature.index.modalTitle")}
				modalState={signRegisterModal}
				setModalToggle={setSignRegisterModal}
				width={500}
				height={380}
				closeable={false}
				className="modal-signatureUpload"
			>
				<SignatureUploadModal {...{
					getSignatureList: () => {},
					uploaderConstant: UPLOAD_TYPE.COMPANY_LOGO,
					setSignImg: setSignImg
				}} />
			</ModalTemplate>
			<Alert
				message={t("Shareholder.ShareholderDetail.Edit.Index.alertMsg")}
				confirm={t("button.check")}
				type="error"
			/>
			<CancelAlert
				message={
					<>
						{t("Shareholder.ShareholderDetail.Edit.Index.cancelAlert.main")}{" "}
						{idx !== undefined
							? t("button.edit").toLowerCase()
							: t("button.register").toLowerCase()}
						{langStatus === "ko" ? "" : "?"}
						{t("Shareholder.ShareholderDetail.Edit.Index.cancelAlert.sub")}
					</>
				}
				confirm={t("button.yes")}
				reject={t("button.No")}
				type={"warning"}
			/>
		</>
	);
};

export default Edit;
